function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 9V8H0V9H1ZM1 23H0V24H1V23ZM18 12H23V10H18V12ZM18 16H22.25V14H18V16ZM18 20H21.25V18H18V20ZM4.75 8H1V10H4.75V8ZM0 9V23H2V9H0ZM1 24H4.75V22H1V24ZM18.044 16H22.294V14H18.044V16ZM18.044 20H21.294V18H18.044V20Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0439 12H21.0439V10H18.0439V12ZM21.0439 12C21.5957 12 22.0439 12.4483 22.0439 13H24.0439C24.0439 11.3437 22.7002 10 21.0439 10V12ZM22.0439 13C22.0439 13.5517 21.5957 14 21.0439 14V16C22.7002 16 24.0439 14.6563 24.0439 13H22.0439ZM21.0439 14H18.0439V16H21.0439V14ZM20.5439 16C21.0957 16 21.5439 16.4483 21.5439 17H23.5439C23.5439 15.3437 22.2002 14 20.5439 14V16ZM21.5439 17C21.5439 17.5517 21.0957 18 20.5439 18V20C22.2002 20 23.5439 18.6563 23.5439 17H21.5439ZM20.5439 18H18.0439V20H20.5439V18Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0439 19C20.1479 19 21.0439 19.896 21.0439 21V21C21.0439 22.104 20.1479 23 19.0439 23H4.99994V8.75L8.82995 2.44C9.43595 1.506 10.1319 1 10.9999 1C11.1839 1 11.3739 1.026 11.5599 1.08C12.6199 1.388 13.2279 2.5 12.9199 3.56L11.7499 7H21.0439C22.1479 7 23.0439 7.896 23.0439 9V9C23.0439 10.104 22.1479 11 21.0439 11H18.0439",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.34d30275.svg";
export { ForwardRef as ReactComponent };